import React from 'react';
import { withRouter } from 'react-router';
// eslint-disable-next-line import/extensions
import { connect } from 'redux-zero/react';
import { injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import OnVisible, { setDefaultProps } from 'react-on-visible';

import { actions } from '../../shared/store.js';
import AboutUsService from './about-us.service.js';

import { Title, SmallTitle } from '../../components/title/title.component.js';

// import PageNotFound from '../../components/not-found/page-not-found.js';

import './about-us.page.scss';

class AboutUsPage extends React.Component {
	static prefetchData = async language => AboutUsService.getData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		const { aboutUs, setLoading } = this.props;

		if (!aboutUs) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const { language } = this.props;

		if (prevProps.language.value !== language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		const { setLoading, setAboutUs, language } = this.props;
		setLoading(true);

		AboutUsPage.prefetchData(language.value)
			.then((data) => {
				setAboutUs(data);
				setLoading(false);
			})
			.catch(() => {
				const { history } = this.props;
				setLoading(false);
				history.push('/404');
				this.setState({
					hasError: true,
				});
			});
	}

	render() {
		const { hasError } = this.state;
		const { intl, aboutUs, mainData } = this.props;

		setDefaultProps({
			visibleClassName: 'visible',
			percent: 20,
		});


		if (hasError || !aboutUs || !mainData) {
			return null;
		}

		const {
			title,
			headerImage,
			whoAreWeDescription1,
			subtitle,
			whatWeDoSubtitle,
			pathwayDescription,
			bodyImage,
			pathwayText,
			emailText,
		} = aboutUs;

		return (
			<div id="about-us-page">
				<Helmet>
					<title>
						{intl.formatMessage({
							id: 'navigation.about-us',
						})}
					</title>
					<meta
						name="description"
						content={subtitle}
					/>
					<link
						rel="canonical"
						href={`${
							process.env.REACT_APP_URL
						}/about-us`}
					/>

					<meta
						property="og:title"
						content={intl.formatMessage({
							id: 'navigation.about-us',
						})}
					/>
					<meta
						property="og:url"
						content={`${
							process.env.REACT_APP_URL
						}/about-us`}
					/>

				</Helmet>

				<section className="initial-section">
					{headerImage.path && (
						<img
							className="initial-section-image"
							src={`${process.env.REACT_APP_API_ENDPOINT + headerImage.path}`}
							alt="About-us-Header"
						/>
					)}
					<div className="container container-fluid">
						<div className="title">
							<div className="title-wrapper">
								<Title label={title} />
							</div>
						</div>
					</div>
				</section>

				<section className="pathfinders">
					<div className="container container-fluid">
						<OnVisible className="row apresentation">
							<div className="col-xs-12 col-md-2 small-title">
								<SmallTitle
									label={intl.formatMessage({ id: 'aboutUs.who_are_we' })}
								/>
							</div>
							<div className="col-xs-12 col-md-10 description">
								<p>{whoAreWeDescription1}</p>
							</div>
							<div className="col-md-offset-2 col-xs-12 email">

								{mainData
									&& (
										<a href={`mailto:${mainData.email}`} className="right">
											{emailText}
										</a>
									)
								}

							</div>
						</OnVisible>
						<div className="second-title">
							<div className="row ">
								<div className="col-md-2" />
								<div className="col-xs-12 col-md-5">
									<OnVisible className="subtitle">
										<h3>{subtitle}</h3>
									</OnVisible>
								</div>
							</div>
							<div className="image-element">
								<OnVisible className="image">
									{bodyImage.path && (
										<img
											src={`${process.env.REACT_APP_API_ENDPOINT + bodyImage.path}`}
											alt="About-us-BodyImage"
										/>
									)}
								</OnVisible>
							</div>
						</div>
					</div>
				</section>

				<section className="what-we-do">
					<div className="container container-fluid">
						<OnVisible className="row">
							<div className="col-xs-12 col-md-4 col-md-offset-2 label">
								<p>{whatWeDoSubtitle}</p>
							</div>
						</OnVisible>
					</div>
				</section>

				<section className="pathway">
					<div className="container container-fluid">
						<OnVisible className="row">
							<div className="col-xs-12 col-md-2">
								<SmallTitle
									label={intl.formatMessage({ id: 'aboutUs.pathway' })}
									theme="dark"
								/>
							</div>
							<div className="col-xs-12 col-md-10 label">
								<h2 className="summary">{pathwayDescription}</h2>
							</div>
							<div className="col-xs-12 col-md-10 col-md-offset-2 text-label">
								<p className="text">{pathwayText}</p>
							</div>
						</OnVisible>
					</div>
				</section>
			</div>
		);
	}
}

const mapToProps = ({
	language,
	aboutUs,
	mainData,
	isLoading,
}) => ({
	language,
	aboutUs,
	mainData,
	isLoading,
});

export default withRouter(
	injectIntl(
		connect(
			mapToProps,
			actions,
		)(AboutUsPage),
	),
);

export { AboutUsPage };
